import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiSearch, FiFilter } = FiIcons;

const SearchBar = ({ onSearch }) => {
  const [query, setQuery] = useState('');
  const [category, setCategory] = useState('all');

  const categories = [
    { value: 'all', label: 'All Categories' },
    { value: 'generic-name', label: 'Generic Name' },
    { value: 'ndc', label: 'Novadoz NDC Number' },
    { value: 'customer', label: 'Customer' },
    { value: 'affiliation-group', label: 'Affiliation Group' }
  ];

  const handleSubmit = (e) => {
    e.preventDefault();
    if (query.trim()) {
      onSearch(query.trim(), category);
    }
  };

  const handleQuickSearch = (searchTerm, searchCategory) => {
    setQuery(searchTerm);
    setCategory(searchCategory);
    onSearch(searchTerm, searchCategory);
  };

  const quickSearches = [
    { term: 'Abiraterone Acetate', category: 'generic-name', type: 'Product' },
    { term: 'Atorvastatin', category: 'generic-name', type: 'Product' },
    { term: 'RedOak Sourcing', category: 'customer', type: 'Customer' },
    { term: 'ClarusOne', category: 'affiliation-group', type: 'Affiliation Group' },
    { term: 'WBAD', category: 'affiliation-group', type: 'Affiliation Group' }
  ];

  return (
    <div className="relative">
      <form onSubmit={handleSubmit} className="relative">
        <div className="flex">
          <div className="relative flex-1">
            <SafeIcon 
              icon={FiSearch} 
              className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" 
            />
            <input
              type="text"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Search products, customers, groups, NDCs..."
              className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-l-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
            />
          </div>
          
          <div className="relative">
            <select
              value={category}
              onChange={(e) => setCategory(e.target.value)}
              className="h-full px-4 py-3 border-t border-b border-gray-300 bg-gray-50 text-gray-700 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
            >
              {categories.map((cat) => (
                <option key={cat.value} value={cat.value}>
                  {cat.label}
                </option>
              ))}
            </select>
          </div>
          
          <button
            type="submit"
            className="px-6 py-3 bg-blue-600 text-white rounded-r-lg hover:bg-blue-700 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all"
          >
            <SafeIcon icon={FiSearch} />
          </button>
        </div>
      </form>

      {/* Quick Search Suggestions */}
      {query && (
        <div className="absolute top-full left-0 right-0 mt-2 bg-white border border-gray-200 rounded-lg shadow-lg z-50 max-h-64 overflow-y-auto">
          <div className="p-4">
            <p className="text-sm font-medium text-gray-700 mb-3">Quick Searches</p>
            <div className="space-y-2">
              {quickSearches
                .filter(item => 
                  item.term.toLowerCase().includes(query.toLowerCase()) ||
                  item.type.toLowerCase().includes(query.toLowerCase())
                )
                .map((item, index) => (
                  <button
                    key={index}
                    onClick={() => handleQuickSearch(item.term, item.category)}
                    className="w-full flex items-center justify-between p-3 hover:bg-gray-50 rounded-lg transition-colors text-left"
                  >
                    <div>
                      <p className="font-medium text-gray-900">{item.term}</p>
                      <p className="text-sm text-gray-600">{item.type}</p>
                    </div>
                    <SafeIcon icon={FiSearch} className="text-gray-400" />
                  </button>
                ))
              }
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchBar;